import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      light: '#ffffff',
      main: '#ffffff',
      dark: '#cccccc',
      contrastText: '#444444',
    },
    secondary: {
      light: '#6ed8ff',
      main: '#22a7f0',
      dark: '#0078bd',
      contrastText: '#ffffff',
    },
  },
})
